import React from 'react'
import { Typography } from '@mui/material'
import { translate } from '../i18n'
import { Clipboard, DialogPopup } from '../components'
import { UserActivatePopupProps } from './UserActivatePopup.types'

export default function UserActivatePopup({
    user,
    onClose,
}: UserActivatePopupProps) {
    return (
        <DialogPopup
            title={translate('users.activation.title')}
            open
            onClose={onClose}
        >
            <Typography variant="body2" paragraph>
                {translate('users.activation.content', user)}
            </Typography>
            <Clipboard
                value={`${process.env.REACT_APP_ROOT_URL}/signin/${
                    user.password_code ?? 'invalid_code'
                }/password`}
            />
        </DialogPopup>
    )
}
